import type { ObjectFieldTemplateProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const ObjectFieldTemplate = ({
  properties,
  description,
  uiSchema
}: ObjectFieldTemplateProps) => {
  const Tag = uiSchema?.['ui:options']?.allowWrap ? Mtds.Flex : Mtds.Grid
  const fieldTemplateShowsDescription = uiSchema?.['ui:label'] === true
  return (
    <Tag data-gap='6'>
      {!fieldTemplateShowsDescription && description && (
        <Mtds.Alert data-color={'info'}>{description}</Mtds.Alert>
      )}
      {properties.map(({ content }) => content)}
    </Tag>
  )
}
